import { render } from "./form-forgot-password.vue?vue&type=template&id=7049831d"
import script from "./form-forgot-password.vue?vue&type=script&lang=js"
export * from "./form-forgot-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__